import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiRequest } from "../../utils/api";
import { useNotification } from "../../context/notification";
import { useHistory } from "react-router-dom";

import { Button } from "@material-ui/core";
import TextField from "../TextField";
import AlertDialog from "../AlertDialog";

import DeleteIcon from "@material-ui/icons/Delete";
import styles from "./index.module.scss";

const MAX_LENGTH = 200;

export default function SessionDeleteButton({
  sessionId,
  isLogsRoute = false,
  ...props
}) {
  const { t } = useTranslation();
  const { addNotification } = useNotification();
  const history = useHistory();

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [isMax, setIsMax] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleReasonChange = event => {
    const value = event.target.value;

    if (value.length <= MAX_LENGTH) {
      setReason(value);
      setIsMax(value.length === MAX_LENGTH);
    }
    setIsError(value.trim() === "" ? true : false);
  };

  const handleDelete = () => {
    // For validation
    handleReasonChange({ target: { value: reason } });

    if (!isError) {
      apiRequest
        .delete(`/api/deleteSession`, {
          data: {
            session_id: sessionId,
            deleted_reason: reason,
          },
        })
        .then(response => {
          if (response.status === 200) {
            if (response.data.status === "error") {
              addNotification(response.data.message, "error");
            } else {
              setIsDialogOpen(false);
              if (isLogsRoute) {
                history.goBack();
              } else {
                history.push("/sessions");
              }

              addNotification(
                t("deleteSession.sessionSuccessfullyDeleted"),
                "success"
              );
            }
          }
        })
        .catch(error => {
          console.error("Error deleting session:", error);
        });
    }
  };

  const getHelperText = () => {
    if (isError) return t("deleteSession.reasonMandatory");
    if (isMax) return t("deleteSession.textLimit");
    return "";
  };

  return (
    <>
      <Button
        className={styles.deleteButton}
        size="large"
        startIcon={<DeleteIcon color="gray" />}
        onClick={() => setIsDialogOpen(true)}
      >
        <span>{t("deleteSession.delete")}</span>
      </Button>
      <AlertDialog
        maxWidth={false}
        PaperProps={{
          style: {
            width: 390,
            maxWidth: "",
            borderRadius: 12
          }
        }}
        title={t("deleteSession.title")}
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        body={
          <>
            <p>{t("deleteSession.message")}</p>
            <TextField
              className={styles.textarea}
              multiline
              rows={4}
              inputProps={{ maxLength: MAX_LENGTH, style: { resize: "both" } }}
              fullWidth
              placeholder={t("deleteSession.reasonPlaceholder")}
              variant="outlined"
              value={reason}
              onChange={handleReasonChange}
              error={isError || isMax}
              helperText={getHelperText()}
            />
          </>
        }
        footer={
          <>
            <Button
              className={styles.button}
              style={{ color: "grey" }}
              onClick={() => {
                setIsDialogOpen(false);
              }}
            >
              {t("deleteSession.cancel")}
            </Button>
            <Button
              className={styles.button}
              color="primary"
              onClick={handleDelete}
              variant="contained"
            >
              {t("deleteSession.deleteSession")}
            </Button>
          </>
        }
      />
    </>
  );
}
